import { CreateCustomerRoutine } from '../redux-routines';

export const initialState = {
  isLoading: false,
  error: null,
};

export const customerCreationReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case CreateCustomerRoutine.SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null
      };
    case CreateCustomerRoutine.REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case CreateCustomerRoutine.FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };

    default:
      return state;
  }
};
